import withField, { withValidationFields } from '../withField'
import Textarea from './Textarea'

const TextareaField = withField(Textarea)
const TextareaWithValidation = withValidationFields(Textarea)

export { TextareaField, TextareaWithValidation }
export default Textarea
